import React from 'react';
import { ArrowRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
interface CTAButtonProps {
  className?: string;
}
export function CTAButton({
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center ${className}`} data-id="element-13">
      <a href="https://www.metodoscaseros.com/cart/49865772564757:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 text-lg font-semibold text-navy-900 bg-gradient-to-r from-amber-500 to-amber-400 rounded-full overflow-hidden transition-all hover:scale-105 hover:shadow-[0_0_30px_-5px_rgba(212,168,83,0.4)] focus:outline-none focus:ring-2 focus:ring-amber-400 focus:ring-offset-2 focus:ring-offset-navy-900 no-underline" data-id="element-14">
        <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-black" data-id="element-15"></span>
        <span className="relative" data-id="element-16">¡QUIERO MI MEMORIA DE ACERO AHORA!</span>
        <ArrowRight className="relative w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-17" />
      </a>
      <p className="mt-3 text-sm text-steel-400 flex items-center gap-2" data-id="element-18">
        <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-19"></span>
        Acceso instantáneo tras la compra. Tu claridad no puede esperar.
      </p>
    </div>;
}